import { VueRegistration } from "@abaco/web-common/src/app";

const globals: VueRegistration = {
    NutritionWidgetTile: {
        meta: {
            i18nDescrKey: "nutrition-chart-tile",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: "COLDIRETTI_PLOT_MONITORING"
        },
        component: () => import("./components/tiles/NutritionWidgetTile.vue")
    },
    IrrigationWidgetTile: {
        meta: {
            i18nDescrKey: "irrigation-chart-tile",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: "COLDIRETTI_PLOT_MONITORING"
        },
        component: () => import("./components/tiles/IrrigationWidgetTile.vue")
    },
    HarvestWidgetTile: {
        meta: {
            i18nDescrKey: "harvest-chart-tile",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: "COLDIRETTI_PLOT_MONITORING"
        },
        component: () => import("./components/tiles/HarvestWidgetTile.vue")
    },
    SowingWidgetTile: {
        meta: {
            i18nDescrKey: "sowing-widget-title",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: "COLDIRETTI_PLOT_MONITORING"
        },
        component: () => import("./components/tiles/SowingAdviceWidgetTile.vue")
    },
    WeatherRiskWidgetTile: {
        meta: {
            i18nDescrKey: "weather-risk-title",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: "COLDIRETTI_PLOT_MONITORING"
        },
        component: () => import("./components/tiles/WeatherRiskWidgetTile.vue")
    },
    DiseaseRiskWidgetTile: {
        meta: {
            i18nDescrKey: "disease-risk-title",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: "COLDIRETTI_PLOT_MONITORING"
        },
        component: () => import("./components/tiles/DiseaseRiskWidgetTile.vue")
    },
};

export default globals;
